import React from 'react';
import ReactDOM from 'react-dom';
import './style.scss';
import phoneIcon from 'assets/imgs/phone-icon.png';
import { YOUR_API_KEY } from 'global/environment';

const loadJS = function (src) {
  var ref = window.document.getElementsByTagName("script")[0];
  var script = window.document.createElement("script");
  script.src = src;
  script.async = true;
  ref.parentNode.insertBefore(script, ref);
}
class GoogleMap extends React.PureComponent {

  componentDidMount() {
    window.initMap = this.initMap;
    loadJS(`https://maps.googleapis.com/maps/api/js?key=${YOUR_API_KEY}&callback=initMap`);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.locationList !== this.props.locationList) {
      if (this.props.locationList && this.props.locationList.length > 0) {
        this.initMap(this.props.locationList[0]);
      }
    }
    if (this.props.locationSelected && prevProps.locationSelected !== this.props.locationSelected) {
      this.initMap(this.props.locationSelected);
    }
  }

  initMap = (item) => {
    const google = window.google;
    try {
      const map = new google.maps.Map(ReactDOM.findDOMNode(this.refs.map), {
        zoom: item?.zoom || 12,
        center: {
          lat: item ? item.lat : 21.019051,
          lng: item ? item.lng : 105.809652
        }
      });
  
      this.getMaker(map);
  
      if (item?.zoom) {
        const marker = new google.maps.Marker({
          position: {
            lat: item.lat,
            lng: item.lng
          },
          map,
        });
  
        const infowindow = this.getInfoWindow(item.index);
        infowindow.open(map, marker);
      }
    } catch (e) {
      console.log(e)
    }
  }

  getInfoWindow = (index) => {
    const google = window.google;
    const item = this.props.locationList[index];
    const contentString =
      `<table>
      <thead>
        <tr>
          <td colSpan="2">Thông tin vị trí</td>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>Địa chỉ</td>
          <td>${item.ADDRESS}</td>
        </tr>

        <tr>
          <td>Điện thoại</td>
          <td>${item.MOBILE} <a href="tel:${item.MOBILE}"><img alt="flag" style="width: 20px; margin-left: 10px; cursor: pointer" src=${phoneIcon} /></a></td>
        </tr>
      </tbody>
    </table>`

    const infoWindow = new google.maps.InfoWindow({
      content: contentString
    });
    return infoWindow;
  }

  getMaker = (map) => {
    const { locationList } = this.props;
    const google = window.google;

    for (let i = 0; i < locationList.length; i++) {
      const item = locationList[i];
      const marker = new google.maps.Marker({
        position: {
          lat: item.lat,
          lng: item.lng
        },
        map,
      });

      const infowindow = this.getInfoWindow(i);
      marker.addListener('click', () => {
        infowindow.open(map, marker);
      });

      google.maps.event.addListener(map, "click", () => {
        infowindow.close();
      });
    }
  }

  render() {
    return (
      <>
        <div ref="map" className="google-map"></div>
      </>
    );
  }
}

export default GoogleMap;
